import UserAdmin from './UserAdmin';
import UserEditor from './UserEditor';
import UserOwner from './UserOwner';

import * as React from 'react';
import { OrgRoles } from 'shared/src/authz/rolesV2';
import { isOrgOwner, isOrgUser, isOrgAdmin } from 'shared/src/authz/validators';

type Props = Readonly<{
  roles: OrgRoles[];
}>;

const User: React.FC<Props & React.SVGProps<SVGSVGElement>> = ({ roles, ...props }) => {
  if (isOrgOwner(roles)) {
    return <UserOwner {...props} />;
  } else if (isOrgAdmin(roles)) {
    return <UserAdmin {...props} />;
  } else if (isOrgUser(roles)) {
    return <UserEditor {...props} />;
  }

  return null;
};

export default User;
